import { Popover } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import IconBass from 'src/components/IconBass';
import lessStyle from './index.module.less';
import { coreConfig, applyConfig, cooConfig } from './config';
import Header from '../components/HomeHeader';

export default function Home() {
  const navigate = useNavigate();
  const gologin = () => {
    navigate('/login');
  };
  return (
    <div className={lessStyle.home}>
      <Header />
      <div
        className={lessStyle['banner-wrap']}
      >
        <div className={lessStyle['banner-info-wrap']}>
          <img
            alt=""
            src={require('./images/banner-title.png')}
            className={lessStyle['banner-info-title']}
          />
          <div className={lessStyle['banner-info-detail']}>
            iLaw核心资产查询系统助力您轻松获取全国范围的核心资产信息，高效赋能专业办案，助力案件分析与资产追踪
          </div>
          <div
            onClick={gologin}
            className={lessStyle['banner-info-button']}
          >
            立即体验
          </div>
        </div>
      </div>
      <div className={lessStyle['core-info-wrap']}>
        <div className={lessStyle['core-info-title']}>
          核心价值
        </div>
        <div className={lessStyle['core-info-list']}>
          {coreConfig.map((item: any) => (
            <div key={item.title} className={lessStyle['core-info-item']}>
              <img
                alt=""
                src={item.img}
                className={lessStyle['core-info-item-img']}
              />
              <div className={lessStyle['core-info-item-title']}>
                {item.title}
              </div>
              <div className={lessStyle['core-info-item-detail']}>
                {item.detail}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className={lessStyle['apply-info-wrap']}>
        <div className={lessStyle['apply-info-title']}>
          应用场景
        </div>
        <div className={lessStyle['apply-info-list']}>
          {applyConfig.map((item: any) => (
            <div key={item.title} className={lessStyle['apply-info-item']}>
              <img
                alt=""
                src={item.img}
                className={lessStyle['apply-info-item-img']}
              />
              <div className={lessStyle['apply-info-item-title']}>
                {item.title}
              </div>
              <div className={lessStyle['apply-info-item-detail']}>
                {item.detail}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className={lessStyle['coo-info-wrap']}>
        <div className={lessStyle['coo-info-title']}>
          合作流程
        </div>
        <div className={lessStyle['coo-info-list']}>
          {cooConfig.map((item: any) => (
            <div key={item.title} className={lessStyle['coo-info-item']}>
              <img
                alt=""
                src={item.img}
                className={lessStyle['coo-info-item-img']}
              />
              <div className={lessStyle['coo-info-item-title']}>
                {item.title}
              </div>
              <div className={lessStyle['coo-info-item-detail']}>
                {item.detail}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className={lessStyle['footer-info-wrap']}>
        <div className={lessStyle['footer-info-title']}>
          全国核心资产数据穿透协查，律师办案增效引擎
        </div>
        <div
          onClick={gologin}
          className={lessStyle['footer-info-button']}
        >
          开启智能协查
        </div>
      </div>
      <Popover
        rootClassName="home-popover-wrap-root-class-name"
        content={(
          <div className={lessStyle['code-wrap']}>
            <img
              className={lessStyle['code-img']}
              src={require('./images/code.png')}
              alt=""
            />
            <div className={lessStyle['code-text']}>
              微信咨询
            </div>
          </div>
        )}
        trigger="hover"
        placement="left"
      >
        <div className={lessStyle['wechat-info-wrap']}>
          <div className={lessStyle.wechatInner}>
            <IconBass type="iconweixin_wechat" className={lessStyle.icon} />
            <div className={lessStyle['wechat-info-text']}>
              微信咨询
            </div>
          </div>
        </div>
      </Popover>
    </div>
  );
}
